import { Navigate, Outlet, useLocation } from "react-router";
import { useAuthContext } from "../hooks/useAuthContext";
import { UserProvider } from "../context/user";

const RouteAuthorized: React.FC = () => {
  const { user } = useAuthContext();
  const { pathname } = useLocation();

  if (!user) {
    const redirect =
      pathname !== "/" ? `?redirect=${encodeURIComponent(pathname)}` : "";

    return <Navigate to={`/login${redirect}`} replace />;
  }

  return (
    <UserProvider user={user}>
      <Outlet />
    </UserProvider>
  );
};

export default RouteAuthorized;
